<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :before-close="closeV"
      title="提示"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="form"
        size="small"
        :rules="rules"
        inline
      >
        <el-alert
        title="确认结束会议，是否继续，请先确认人员参会状态！"
        type="warning"
        show-icon
      >
      </el-alert>
        <el-form-item label="是否召开" prop="is_held">
           <el-radio-group v-model="form.is_held">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="2">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <br>
        <div v-show="form.is_held === 1">
        <el-form-item label="是否需要评分" prop="is_need_score">
          <el-radio-group v-model="form.is_need_score">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="2">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <br>
          <el-form-item label="确认会议时间" prop="estimate_start_time">
          <el-date-picker
            v-model="form.estimate_start_time"
            clearable
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间"
            ></el-date-picker
          > -
        </el-form-item>
        <el-form-item label="" prop="estimate_end_time">
          <el-date-picker
            v-model="form.estimate_end_time"
            clearable
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间"
            >
          </el-date-picker>
        </el-form-item>
        </div>

      </el-form>

      <div v-show="form.is_held === 1">
        <el-tabs v-model="activeName">
        <el-tab-pane label="参会统计" name="first">
        <el-table :data="tableData" :header-cell-style="{
          background: '#41A1FF',
          color: '#fff',
          textAlign: 'center',
        }" style="width: 100%">
          <el-table-column prop="name" label="参会人" align="center">
          </el-table-column>
          <el-table-column prop="u_status" label="参会状态" align="center">
            <template slot-scope="scope">
              <el-select
                size="mini"
                v-model="scope.row.u_status"
                placeholder="请选择"
              >
                <el-option label="待开会" :value="0"></el-option>
                <el-option label="参加" :value="1"></el-option>
                <el-option label="请假" :value="2"></el-option>
                <el-option label="早退" :value="3"></el-option>
                <el-option label="拒绝" :value="4"></el-option>
                <el-option label="缺席" :value="5"></el-option>
                <el-option
                  label="会议取消不需要开会"
                  :value="6"
                ></el-option>
                <el-option label="会议未进行" :value="7"></el-option>
              </el-select>
            </template>
          </el-table-column>
        </el-table>
        </el-tab-pane>
        </el-tabs>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeV()">取 消</el-button>
        <el-button v-loading="loading" size="small" type="primary" @click="submitEnd"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as Api from '@/api/seedetails'

import { meetingend } from '@/api/seedetails'

export default {
  props: {
    propData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      form: { is_held: 1, estimate_start_time: '', estimate_end_time: '', is_need_score: 1 },
      rules: {
        estimate_start_time: [{ required: true, message: '请选择', trigger: 'change' }],
        estimate_end_time: [{ required: true, message: '请选择', trigger: 'change' }],
        is_need_score: [{
          required: true,
          message: '请选择是否需要评分',
          trigger: 'change'
        }]
      },
      tableData: [],
      activeName: 'first'
    }
  },
  watch: {
    'propData.form'(val) {
      this.form = { ...this.propData.form }
      console.log(this.form)
    },
    'propData.visible'(val) {
      this.dialogVisible = val
      if (val) {
        this.getAttendeessearch()
      }
    },
    deep: true
  },
  methods: {
    closeV(type) {
      this.$emit('close', type)
    },
    getAttendeessearch() {
      const params = {
        meeting_id: this.form.id,
        page: 1,
        page_size: 1000
      }
      this.tableData = []
      Api.attendeessearch(params)
        .then((response) => {
          this.tableData = response.data.attendees
        })
        .catch((err) => {
          console.log(err)
        })
    },
    submitEnd() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const attendees = []
          this.tableData.forEach((element) => {
            const obj = {
              name: element.name,
              workcode: element.workcode,
              u_status: element.u_status
            }
            attendees.push(obj)
          })
          const params = {
            meeting_id: this.form.id,
            is_night: 0, // 是否早、晚会
            is_dzh: 1, // 是否大杂会
            is_held: this.form.is_held // 是否召开
          }
          if (this.form.is_held === 1) {
            params.estimate_start_time = this.form.estimate_start_time
            params.estimate_end_time = this.form.estimate_end_time
            params.is_need_score = this.form.is_need_score
            params.attendees = attendees
          }
          this.loading = true

          meetingend(params)
            .then((res) => {
              if (res.code === 'success') {
                this.$message.success('成功！')
                this.$refs.form.resetFields()
                this.closeV(true)
              }
              this.loading = false
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          return false
        }
      })
    }
  }
}
</script>
